<template>
  <div class="d-flex flex-col justify-center max-w-[130px]">
    <label
      for="total-inbound-confirm"
      class="text-[14px] text-[#333333]"
    >
      Jumlah
    </label>
    <b-input-group>
      <b-input-group-prepend>
        <b-button
          variant="light"
          class="!border-[#E2E2E2]"
          size="sm"
          :disabled="value <= 0 || disabled"
          @click="handleDecrement"
        >
          <span>-</span>
        </b-button>
      </b-input-group-prepend>
      <b-input
        id="total-inbound-confirm"
        class="text-center"
        min="0"
        number
        :value="value"
        :formatter="numberFormatter"
        :disabled="disabled"
        @input="handleInput"
      />
      <b-input-group-append>
        <b-button
          variant="light"
          class="!border-[#E2E2E2]"
          size="sm"
          :disabled="disabled"
          @click="handleIncrement"
        >
          <span>+</span>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import { numberFormatter } from '@/libs/helpers'

/**
 * TotalInboundConfirmCell component
 * @description This component is used to isolate the total inbound confirm input with decrement and increment button.
 */
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    requestedTotalInbound: {
      type: Number,
      required: false,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    numberFormatter,
    handleDecrement() {
      this.$emit('input', this.value - 1)
    },
    handleIncrement() {
      this.$emit('input', this.value + 1)
    },
    handleInput(value) {
      this.$emit('input', value)
    },
  },
}
</script>
